import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setChequeReportRequestData, setChequeReportResponseData} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import Pagination from "../../../primer/Pagination";
import axios from "axios";
import {toast} from "react-toastify";
import moment from "moment";
import Input from "../../../common/Input";
import {getGreekCurrencyFormat, isEmpty} from "../../../../_helpers/commonFunctions";
import Dropdown from "../../../primer/Dropdown";
import {openClientPayment, openSupplierPayment} from "../../../../_helpers/tabOpeners";

const ChequeReport = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const requestData = useSelector((state) => state.CASH_DATA.chequeReportRequestData);
    const responseData = useSelector((state) => state.CASH_DATA.chequeReportResponseData);
    const setRequestData = (data) => dispatch(setChequeReportRequestData(data));
    const setResponseData = (data) => dispatch(setChequeReportResponseData(data));

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);

    const typeOptions = [
        {value: "", label: "Προβολή όλων"},
        {value: 0, label: "Προβολή εισπρακτηκών"},
        {value: 1, label: "Προβολή πληρωτέων"},
    ]

    const statusOptions = [
        {value: "", label: "Προβολή όλων"},
        {value: "redeemed", label: "Προβολή εξοφλημένων"},
        {value: "redeemable", label: "Προβολή εξοφλίσημων"},
        {value: "expired", label: "Προβολή ληγμένων"},
    ]

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged])

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            setRequestData(reqData);
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/cash/cheque-report`, {
            ...reqData,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                setResponseData(res.data);
                if (!fromPagination) toast.success("Επιτυχής ανανέωση δεδομένων.", {autoClose: 1000});
            } else {
                if (!fromPagination) toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onPageChange = (page) => {
        setPageChanged(true);
        setRequestData({...requestData, page});
    }

    const handleFilterChange = (e, type, name) => {
        const prepChange = {};
        if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "dd") {
            prepChange[name] = e.value;
        }
        setRequestData({...requestData, ...prepChange});
    }

    const handleOpenDocument = (cc) => {
        if (cc.used) {
            if (cc.type === 0) {
                openClientPayment(dispatch, TABS_DATA, company.id, cc.document);
            } else if (cc.type === 1) {
                openSupplierPayment(dispatch, TABS_DATA, company.id, cc.document);
            }
        }
    }

    const getBackgroundColor = (cc) => {
        if (cc.used) return "#c6f3da"; // Redeemed
        else if (!cc.used && isEmpty(cc.expiryDate)) return "#badcf5"; // Can be redeemed
        else if (!cc.used && moment(cc.expiryDate).hour(11) > moment().hour(10)) return "#badcf5"; // Can be redeemed
        else if (!cc.used && moment(cc.expiryDate).hour(10) < moment().hour(10)) return "#f6cac5"; // Expired

        return "";
    }

    return (
        <div>
            <div onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false);
            }}>
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Dropdown
                            name={"type"}
                            label={"Τύπος Επιταγής"}
                            key={Math.random()}
                            defaultValue={typeOptions.find((el) => el.value === requestData.type)}
                            options={typeOptions}
                            onChange={(e) => handleFilterChange(e, "dd", "type")}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            name={"numbering"}
                            label={"Αριθμός Επιταγής"}
                            value={requestData.numbering}
                            onChange={(e) => handleFilterChange(e, "input", "numbering")}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            name={"entityName"}
                            label={"Συσχετιζόμενη Οντότητα"}
                            value={requestData.entityName}
                            onChange={(e) => handleFilterChange(e, "input", "entityName")}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"status"}
                            label={"Κατάσταση Επιταγής"}
                            key={Math.random()}
                            defaultValue={statusOptions.find((el) => el.value === requestData.status)}
                            options={statusOptions}
                            onChange={(e) => handleFilterChange(e, "dd", "status")}
                        />
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col md={2}>
                        <Input
                            name={"amountFrom"}
                            label={"Ποσό από"}
                            type={"number"}
                            value={requestData.amountFrom}
                            onChange={(e) => handleFilterChange(e, "input", "amountFrom")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            name={"amountTo"}
                            label={"Ποσό έως"}
                            type={"number"}
                            value={requestData.amountTo}
                            onChange={(e) => handleFilterChange(e, "input", "amountTo")}
                        />
                    </Col>
                    <Col md={8} className={"d-flex justify-content-end"}>
                        <Button style={{marginTop: "23px"}} onClick={() => fetchReport(false)} disabled={loading}>
                            Εφαρμογή Φίλτρων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                </Row>
            </div>
            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <Row className={"mb-2"}>
                        <Col md={12} className="d-flex flex-column flex-md-row justify-content-end align-items-center align-items-md-start">
                            <div className="mr-md-3 mt-2 mb-2 mb-md-0 text-center text-md-right">
                                <i style={{ whiteSpace: 'nowrap' }}>
                                    Σύνολο Αποτελεσμάτων: {responseData.totalItems}
                                </i>
                            </div>
                            <div className="d-flex justify-content-center justify-content-md-end">
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={(e) => onPageChange(e)}
                                    maxWidth={400}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <table className={"transfers-table"}>
                                <thead>
                                <tr>
                                    <th>Αρ. Επιταγής</th>
                                    <th>Τύπος Επιταγής</th>
                                    <th>Ημ/νια Έκδοσης</th>
                                    <th>Ημ/νια Λήξης</th>
                                    <th>Συσχετιζόμενη Οντότητα</th>
                                    <th>Ποσό</th>
                                    <th>Εξοφλημένη</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((cc, idx) => (
                                    <tr key={`ct-${idx}`} style={{backgroundColor: getBackgroundColor(cc)}}>
                                        <td>{cc.numbering}</td>
                                        <td>{cc.type === 0 ? "Εισπρακτική" : "Πληρωτέα"}</td>
                                        <td>{moment(cc.issueDate).format("DD/MM/YYYY")}</td>
                                        <td>{moment(cc.expiryDate).isValid() ? moment(cc.expiryDate).format("DD/MM/YYYY") : "-"}</td>
                                        <td>{cc.entityName}</td>
                                        <td>{getGreekCurrencyFormat(cc.amount)}</td>
                                        <td style={{cursor: cc.used ? "pointer" : ""}} onClick={() => handleOpenDocument(cc)}>{cc.used ? <u>Ναι</u> : "Όχι"}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className={"mt-3 d-flex justify-content-end"}>
                        <Col md={4}>
                            <table className={"transfers-table"}>
                                <thead>
                                <tr>
                                    <th colSpan={2}>Σύνολα</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#c6f3da"}}>
                                    <td style={{fontWeight: 600}}>Συνολικό Ποσό Εξοφλημένων</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalRedeemed)}</td>
                                </tr>
                                <tr style={{backgroundColor: "#badcf5"}}>
                                    <td style={{fontWeight: 600}}>Συνολικό Ποσό Εξοφλίσιμων</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalRedeemable)}</td>
                                </tr>
                                <tr style={{backgroundColor: "#f6cac5"}}>
                                    <td style={{fontWeight: 600}}>Συνολικό Ποσό Λημένων</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalExpired)}</td>
                                </tr>
                                <tr>
                                    <td style={{fontWeight: 600}}>Συνολικό Ποσό</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.totalAmount)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </div>
    )
}

export default ChequeReport;
